import Vue from 'vue';
import store from '@/store';
import { Notification } from 'element-ui';

export function formartBody(jsonData) {
    let paramsArray = [];
    Object.keys(jsonData).forEach(key => paramsArray.push(key + '=' + jsonData[key]));
    return paramsArray.join('&');
}

/**
 * Object转FormData
 * @param {*} params
 */
export function renderFormData(params) {
    const data = new FormData();
    for (let [key, value] of Object.entries(params)) {
        data.append(key, value);
    }
    return data;
}

/**
 * 根据type返回不同格式的response
 */
const _returnContentByType = function (response) {
    var type = response.headers.get('Content-Type').split(';')[0];
    switch (type) {
        case 'text/html':
            return response.text();
            break;
        case 'application/json':
            return response.json();
            break;
        default:
    }
};

const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    402: '用户登录过期请重新登录。',
    403: '用户访问是被禁止的，没有权限访问。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};
/**
 * 检查http返回的状态码
 * @param {*} response
 * @returns
 */
function checkHttpStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const errortext = codeMessage[response.status] || response.statusText;

    Notification.error({
        title: `请求错误: ${response.status}`,
        message: `${response.url} \n ${errortext}`,
    });
    const error = new Error(errortext);
    error.name = response.status;
    error.response = response;
    throw error;
}
/**
 * 检查自定义返回的状态码
 * @param {*} res
 * @returns
 */
function getStatus(res) {
    if (res.state != 1) {
        Notification.error({
            title: '错误',
            message: `${res.message}`,
        });
    }
    return res;
}

/**
 * fetch 方式
 */
export function request(url, options) {
    const defaultOptions = {
        credentials: 'include', //表示请求是否携带cookie
        headers: {},
    };
    const newOptions = { ...defaultOptions, ...options };
    if (newOptions.method === 'POST' || newOptions.method === 'PUT' || newOptions.method === 'DELETE') {
        if (!(newOptions.body instanceof FormData)) {
            newOptions.headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                ...newOptions.headers,
            };
            newOptions.body = JSON.stringify(newOptions.body);
        } else {
            // newOptions.body is FormData
            newOptions.headers = {
                Accept: 'application/json',
                ...newOptions.headers,
            };
        }
    }
    return fetch(url, newOptions)
        .then(checkHttpStatus)
        .then(response => {
            if (newOptions.method === 'DELETE' || response.status === 204) {
                return response.text();
            }
            return response.json();
        })
        .then(getStatus)
        .catch(e => {
            const { dispatch } = store;
            const status = e.name;
            if (status === 401 || status === 402) {
                window.location.reload();
                dispatch({
                    type: 'ImsUsers/logout',
                });
                return;
            } else {
                return;
            }
        });
}

/**
 * axios 请求方式
 * @param {*} url
 * @param {*} options
 */
export function requestByAxios(url, options) {
    const defaultOptions = {
        headers: {
            Accept: 'application/json, */*',
        },
    };
    const newOptions = { ...defaultOptions, ...options, url };

    if (!(newOptions.data instanceof FormData) && !(newOptions.data instanceof URLSearchParams)) {
        newOptions.headers = {
            'Content-Type': 'application/json; charset=utf-8',
            ...newOptions.headers,
        };
    } else {
        newOptions.headers = {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            ...newOptions.headers,
        };
    }

    // 设置权限token
    const token = Vue.cookie.get('clscm.session.id');
    if (token) {
        newOptions.headers.AccessToken = token;
    }
    return axios(newOptions)
        .then(axiosgetStatus)
        .catch(e => {
            const { dispatch } = store;
            const { response } = e;
            const { status, statusText, config, data } = response;
            const errortext = data.message || codeMessage[status] || statusText;
            // console.log(response);

            Notification.error({
                title: `请求错误: ${status}: ${config.url}`,
                message: errortext,
            });

            if (status === 401 || status === 402) {
                window.location.reload();
                dispatch({
                    type: 'ImsUsers/logout',
                });
                return;
            }

            return data;
        });
}



// WEBPACK FOOTER //
// ./src/utils/request.js